import { ApplicationService, DictionariesService } from '@acme/api/client';
import type { DropdownSelectOption } from '@acme/foundation';
import { createEffect, createEvent, createStore, sample } from 'effector';

export const pageOpened = createEvent();

export const loadDataFx = createEffect(async () => {
  const [categoriesResponse, applicationsResponse] = await Promise.all([
    DictionariesService.getApiV1DictionariesTicketCategories(),
    ApplicationService.getApiV1ApplicationList({ pageNumber: 1, pageSize: 50 }),
  ]);

  const categories: DropdownSelectOption[] = (
    categoriesResponse.data ?? []
  ).map((cat) => ({
    value: String(cat.id),
    label: cat.name || '',
  }));

  const applications: DropdownSelectOption[] = (
    applicationsResponse.data?.items ?? []
  ).map((app) => ({
    value: app.id ?? '',
    label: `${app.code}-${app.name}`,
  }));

  return { categories, applications };
});

export const $categories = createStore<DropdownSelectOption[]>([]).on(
  loadDataFx.doneData,
  (_, data) => data.categories
);

export const $applications = createStore<DropdownSelectOption[]>([]).on(
  loadDataFx.doneData,
  (_, data) => data.applications.filter((a) => a.value)
);

export const $isLoading = loadDataFx.pending;

export const $error = createStore<string | null>(null)
  .on(pageOpened, () => null)
  .on(loadDataFx.failData, () => 'Ошибка загрузки данных. Попробуйте позже.');

sample({
  clock: pageOpened,
  target: loadDataFx,
});
